import * as React from "react";

import { graphql } from "gatsby";
import { GatsbyImage, GatsbyImageProps, getImage } from "gatsby-plugin-image";

import { Image } from "./OptimizedImage.styles";
export interface OptimizedImageProps {
  image: Queries.SanityImage;
  alt?: string | null;
  imageFit?: GatsbyImageProps["objectFit"] | undefined;
}

const OptimizedImage: React.FC<OptimizedImageProps> = ({
  image,
  alt,
  imageFit,
}) => {
  if (
    !image.asset?.localFile?.childImageSharp &&
    !image.asset?.localFile?.publicURL
  ) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn("Missing image data", image);
    }

    return null;
  }

  if (!image.asset.localFile.childImageSharp?.gatsbyImageData) {
    return (
      <Image
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        src={image.asset.localFile.publicURL!}
        alt={alt ?? ""}
      />
    );
  }

  return (
    <GatsbyImage
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      image={getImage(image.asset.localFile.childImageSharp?.gatsbyImageData)!}
      alt={alt ?? ""}
      objectFit={imageFit == null ? "cover" : imageFit}
    />
  );
};

export const query = graphql`
  fragment OptimizedImage on SanityImage {
    asset {
      _id
      localFile {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
        publicURL
      }
    }
  }
`;

export default OptimizedImage;
